
import React from 'react';
import coin from "../../assets/img/icons/coinT.svg";
const ViewHeaderLink = ({ pagename, details }) => {
    const separator = <span style={{ color: "#000", margin: "0 10px" }}>|</span>;

    return (
        <div style={{
            width: "100%",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
            padding: "25px 0",
            background: "#fff",
            margin: "auto"
        }}>
            <ul style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                gap: "80px",
                listStyle: "none",
                padding: "20px 10px, 20px, 10px ",
                margin: 0,
                fontSize: "18px",
                color: "#000000",
                fontWeight: "500"
            }}>
                {Boolean(details?.first && String(details.first).trim() !== "" && !/^[xX\-\s]+$/.test(String(details.first).trim()) && String(details.first).trim().toUpperCase() !== "NA" && String(details.first).trim().toUpperCase() !== "N/A") && (
                    <li>E-ISSN: <span style={{ color: "#333" }}>{details.first}</span></li>
                )}

                <li>
                    <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center" }}>
                        <img src={coin} alt="CC License" style={{ height: "18px" }} />
                    </a>
                </li>
                {details.second !== '' && <><li>{details.second}</li></>}
                {details.fourth !== '' && <><li>{details.fourth}</li></>}

                <li>Open Peer Review</li>

                <li>Interdisciplinary</li>

                <li>Open Access</li>
            </ul>
        </div>
    );
};
export default ViewHeaderLink